import React from 'react';
import { List, } from 'athenaeum';

import styles from '../menu.module.scss';
import PrimaryMenuHeader from '../PrimaryMenuHeader';
import MenuLink from '../MenuLink';
import insuranceProducts from '../../data/products';
import magazineItems from '../../data/magazineItems';
import aboutItems from '../../data/aboutItems';

const PrimaryMenu = props => (
  <List
    horizontal={{}}
    className={styles['primary-menu']}
  >
    <PrimaryMenuHeader
      header="Insurance Quotes & Guides"
      activeName="insurance"
      submenu={insuranceProducts}
      displayType="product"
      {...props}
    />
    <MenuLink
      header="Insurance Checkup"
      activeName="checkup"
      href="/insurance-checkup-and-advice/"
      {...props}
    />
    <PrimaryMenuHeader
      header="Magazine"
      activeName="magazine"
      submenu={magazineItems}
      displayType="magazine"
      href="/blog/"
      {...props}
    />
    <PrimaryMenuHeader
      header="About"
      activeName="about"
      submenu={aboutItems}
      {...props}
    />
    <MenuLink
      header="Contact"
      href="/about/contact/"
      activeName="contact"
      {...props}
    />
  </List>
);

export default PrimaryMenu;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Menu/PrimaryMenu/index.js